import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Chip, CircularProgress } from "@mui/material";
import { GetMultiSelectTestSlates } from "../../services/TestLibService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "./CommonLoader";

const MultiSelectSlates = ({ value, onChange }) => {
  const [slates, setSlates] = useState([]);
  const [selectedSlates, setSelectedSlates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetMultiSelectTestSlates();
        const slatesData = response.results.map((slate) => slate.jobId.trim());
        patchNewValues(slatesData);

        setLoading(false);
      } catch (error) {
        NotificationManager.error("Error fetching slates:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    patchNewValues(slates);
  }, [value,slates]);

  const patchNewValues = (slatesData) => {
    
    setSlates(slatesData);
    if (value && slatesData.length > 0) {
      const jobIdsArray = value.split(",").map((id) => id.trim());
      setSelectedSlates(jobIdsArray);
    }
   
  };

  useEffect(() => {
    if (onChange) {
      const slateIds = selectedSlates.join(",");
      onChange(slateIds);
    }
  }, [selectedSlates, onChange]);

  return (
    <>
      <Autocomplete
        multiple
        options={slates}
        getOptionLabel={(option) => option}
        value={selectedSlates}
        fullWidth
        size="small"
        // Always allow adding the same option multiple times by returning false
        isOptionEqualToValue={() => false}
        onChange={(event, newValue) => {
          setSelectedSlates(newValue);
        }}
        renderTags={(selected, getTagProps) =>
          selected.map((option, index) => (
            <Chip key={index} label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Sample Slates"
            variant="outlined"
            margin="dense"
          />
        )}
      />
      <CommonLoader loading={loading} />
    </>
  );
};

export default MultiSelectSlates;
